import axios from "axios";
import {
  SET_LOADER,
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  SUPERADMIN_ALL_OFFER_LIST,
  UPDATE_ADMIN_OFFER_STATUS,
  SUPERADMIN_RESTAURANT_OFFER_LIST,
  GET_OFFER_DETAIL_FROM_ID,
  UPDATE_CAROUSEL_RESTAURANT_OFFER,
  SUPERADMIN_RESTAURANT_DELETE_OFFER,
  SUPERADMIN_GET_CITY_FROM_COUNTRY,
  SUPERADMIN_GET_RESTAURANT_FROM_CITY_COUNTRY,
  SUPERADMIN_DELETE_OFFER,
} from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../errorActions";
import { serverApi } from "../../../config/Keys";

export const getAllAdminOffers =
  (token, onSuccessGetAdminOffer, onErrorGetAdminOffer, startDate, endDate) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let get_admin_offers = await axios.get(
          `${serverApi}/admin/offers?globalOffer=true&startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (get_admin_offers.status === 200) {
          onSuccessGetAdminOffer();
          dispatch({ type: CLEAR_LOADER });
          dispatch({
            type: SUPERADMIN_ALL_OFFER_LIST,
            payload: get_admin_offers.data,
          });
        } else {
          onErrorGetAdminOffer();
        }
      } catch (err) {
        onErrorGetAdminOffer();
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
    };

export const changeAdminOfferStatus =
  (token, offerId, formData, onSuccessEdit, onErrorEdit) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let update_admin_offer_status = await axios.patch(
          `${serverApi}/admin/offers/${offerId}`,
          formData,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (update_admin_offer_status.status === 200) {
          update_admin_offer_status.data._id = offerId;
          dispatch({ type: CLEAR_LOADER });
          dispatch({
            type: UPDATE_ADMIN_OFFER_STATUS,
            payload: update_admin_offer_status.data,
          });
          onSuccessEdit(update_admin_offer_status);
        }
      } catch (err) {
        onErrorEdit(err.response.data.message)
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
    };

export const deleteAdminOffer =
  (offerId, token, onSuccessDeleteOffer, onErrorDeleteOffer) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let delete_restaurant_offer = await axios.delete(
          `${serverApi}/offers/${offerId}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (delete_restaurant_offer.status === 200) {
          onSuccessDeleteOffer();
          Alert.success(`<h4>Offer deleted Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          dispatch({ type: CLEAR_LOADER });
          dispatch({
            type: SUPERADMIN_DELETE_OFFER,
            payload: offerId,
          });
        }
      } catch (err) {
        onErrorDeleteOffer();
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
    };

export const getAllAdminRestaurantOffers =
  (token, startDate, endDate, onSuccessGetResOffers, onErrorGetResOffers) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      try {
        let get_restaurant_offers = await axios.get(
          `${serverApi}/admin/offers?startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (get_restaurant_offers.status === 200) {
          dispatch({
            type: SUPERADMIN_RESTAURANT_OFFER_LIST,
            payload: get_restaurant_offers.data,
          });
          dispatch({ type: CLEAR_LOADER });
        }
        onSuccessGetResOffers();
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
      onErrorGetResOffers();
    };

export const getRestaurantOfferDetailFromOfferID =
  (token, offerId, onSuccessDetailOffer, onErrorDetailOffer) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });

      try {
        let get_offer_detail_fromID = await axios.get(
          `${serverApi}/admin/offers/${offerId}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (get_offer_detail_fromID.status === 200) {
          dispatch({ type: CLEAR_LOADER });
          dispatch({
            type: GET_OFFER_DETAIL_FROM_ID,
            payload: get_offer_detail_fromID.data,
          });
          onSuccessDetailOffer(get_offer_detail_fromID.data);
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
        onErrorDetailOffer();
      }
    };

export const addAdminOffer =
  (token, formData, onSuccessAddOffer, onErrorAddOffer) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let add_offer_admin_restaurant = await axios.post(
        `${serverApi}/admin/offers/?globalOffer=true`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_offer_admin_restaurant.status === 201) {
        dispatch({ type: CLEAR_LOADER });

        Alert.success(`<h4>Offer Added Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });

        onSuccessAddOffer();
      }
    } catch (err) {
      Alert.error(`<h4>${err.response.data.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
    onErrorAddOffer();
  };

export const addOfferAdminRestaurant =
  (token, formData, onSuccessAddOffer, onErrorAddOffer) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let add_offer_admin_restaurant = await axios.post(
        `${serverApi}/admin/offers`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_offer_admin_restaurant.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        // dispatch({
        //   type: SUPERADMIN_ADD_NEW_OFFER_RESTAURANT,
        //   payload: add_offer_admin_restaurant.data,
        // });
        Alert.success(`<h4>Offer Added Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        //this.props.history.push("/restaurantadminoffers");

        onSuccessAddOffer();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
    onErrorAddOffer();
  };

export const editRestaurantMainCarousel =
  (token, offerId, formData, onSuccessEdit, onErrorEdit) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });

      try {
        let update_restaurant_main_carousel = await axios.patch(
          `${serverApi}/admin/offers/${offerId}`,
          formData,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (update_restaurant_main_carousel.status === 200) {
          update_restaurant_main_carousel.data._id = offerId;
          dispatch({ type: CLEAR_LOADER });
          dispatch({
            type: UPDATE_CAROUSEL_RESTAURANT_OFFER,
            payload: update_restaurant_main_carousel.data,
          });
        }
        onSuccessEdit();
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
      onErrorEdit();
    };

export const editOfflineOffer =
  (token, offerId, formData, onSuccessEditOffer, onErrorEditOffer) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });

      try {
        let update_restaurant_offer = await axios.patch(
          `${serverApi}/admin/offers/${offerId}`,
          formData,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (update_restaurant_offer.status === 200) {
          Alert.success(`<h4>Offer Edited Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          dispatch({ type: CLEAR_LOADER });
          onSuccessEditOffer();
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
      onErrorEditOffer();
    };

export const deleteRestaurantOffer =
  (offerId, token, onSuccessDeleteOffer, onErrorDeleteOffer) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let delete_restaurant_offer = await axios.delete(
          `${serverApi}/offers/${offerId}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (delete_restaurant_offer.status === 200) {
          onSuccessDeleteOffer();
          Alert.success(`<h4>Offer deleted Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          dispatch({ type: CLEAR_LOADER });
          dispatch({
            type: SUPERADMIN_RESTAURANT_DELETE_OFFER,
            payload: offerId,
          });
        }
      } catch (err) {
        onErrorDeleteOffer();
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
    };

export const getCityFromCountry =
  (countryName, token, onSuccessGetCity, onErrorGetCity) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let get_city_from_country = await axios.get(
          `${serverApi}/admin/offers?getCity=true&countryName=${countryName}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (get_city_from_country.status === 200) {
          onSuccessGetCity(get_city_from_country.data);
          dispatch({ type: CLEAR_LOADER });
          dispatch({
            type: SUPERADMIN_GET_CITY_FROM_COUNTRY,
            //payload: offerId,
          });
        } else {
          onErrorGetCity();
        }
      } catch (err) {
        onErrorGetCity();
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
    };

export const getRestaurantByCityName =
  (
    countryName,
    cityName,
    token,
    onSuccessGetRestaurant,
    onErrorGetRestaurant
  ) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let get_restaurant_from_city = await axios.get(
          `${serverApi}/admin/offers?getrestaurant=true&countryName=${countryName}&cityName=${cityName}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (get_restaurant_from_city.status === 200) {
          onSuccessGetRestaurant(get_restaurant_from_city.data);

          dispatch({ type: CLEAR_LOADER });
          dispatch({
            type: SUPERADMIN_GET_RESTAURANT_FROM_CITY_COUNTRY,
            //payload: offerId,
          });
        } else {
          onErrorGetRestaurant();
        }
      } catch (err) {
        onErrorGetRestaurant();
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
    };
